import { ChevronLeft, ChevronRight } from '@styled-icons/boxicons-regular'
import useFetch from 'hooks/useFetch'
import { translate } from 'locales/index'
import { orderBy } from 'lodash'
import moment from 'moment'
import 'moment/locale/pt-br'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { useUser } from 'context/user/user.context'

import { Footer, Header, Loading, ReminderAlert } from 'components'

import icon1 from 'assets/icons/1.svg'
import icon2 from 'assets/icons/2.svg'
import icon3 from 'assets/icons/3.svg'
import icon4 from 'assets/icons/4.svg'

import { IDashMetrics } from './Interfaces'
import { findDashMetrics } from './services'
import * as S from './styles'

import { findUserData, schedulingListFormated } from '../Home/services'
import { psicoName } from '../Home/utils'

const Dash = () => {
  const history = useHistory()
  const { setUserData } = useUser()

  const [period, setPeriod] = useState<{ month: number; year: number }>({
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
  })

  const [metricsLoading, setMetricsLoading] = useState(false)
  const [metrics, setMetrics] = useState<IDashMetrics>({
    doctor_id: '',
    total: '0',
    pending: '0',
    started: '0',
    finished: '0',
    finished_60: '0',
    noshow: '0',
    noshow_60: '0',
    canceled_by_30_min: '0',
    canceled_60_by_30_min: '0',
    canceled: '0',
    slots_occupied: '0',
    slots_total: '0',
  })

  const dataInStorage: any = window.localStorage.getItem('@StarBem:user')
  const dataParse = JSON.parse(dataInStorage)

  const today = moment().format('YYYY-MM-DD')
  const { data, isLoading } = useFetch({
    url: `schedulings/ms/v1/doctor/${dataParse.id}/all?start=${today}&end=${today}`,
    options: {
      revalidateOnMount: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  })

  const { data: slotsVerification } = useFetch({
    url: `schedule/v1/schedules/verify-quantity-slots?user_id=${dataParse.id}`,
    options: {
      revalidateOnMount: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  })

  const findAll = async () => {
    await findUserData(setUserData)
  }

  useEffect(() => {
    findAll()
  }, [])

  const handleAppointmentSelection = (
    appointmentId: string,
    areaName: string
  ) => {
    if (psicoName.includes(areaName)) {
      const area = String(areaName).normalize('NFD').toLowerCase()
      history.push(`/${area}/novo-prontuario/${appointmentId}`)
    } else {
      history.push(`/novo-prontuario/${appointmentId}`)
    }
  }

  const addPeriod = () => {
    if (period.month < 12) {
      setPeriod({
        ...period,
        month: period.month + 1,
      })
    } else if (period.month === 12) {
      setPeriod({
        ...period,
        month: 1,
        year: period.year + 1,
      })
    }
  }

  const subPeriod = () => {
    if (period.month > 1) {
      setPeriod({
        ...period,
        month: period.month - 1,
      })
    } else if (period.month === 1) {
      setPeriod({
        ...period,
        month: 12,
        year: period.year - 1,
      })
    }
  }

  useEffect(() => {
    const monthFormatted = `${period.year}-${String(period.month).padStart(2, '0')}`
    findDashMetrics(setMetrics, monthFormatted, setMetricsLoading)
  }, [period])

  const todayPatients = schedulingListFormated(data).todayPatientsList

  return (
    <S.Container>
      {(isLoading || metricsLoading) && (
        <Loading title={translate('dash.loading')} />
      )}
      <Header />

      <S.Content>
        <S.Title>{translate('dash.title')}</S.Title>

        <S.GridContainer container>
          <S.LeftSection>
            <S.CardContainer>
              <S.SectionTitle>{translate('dash.patientsToday')}</S.SectionTitle>
              <S.PatientsList>
                {todayPatients.length === 0 ? (
                  <S.EmptyState>
                    {translate('home.notScheduleToday')}
                  </S.EmptyState>
                ) : (
                  orderBy(todayPatients, ['date'], ['asc']).map((item: any) => (
                    <S.PatientCard
                      key={item?.uuid}
                      onClick={() =>
                        handleAppointmentSelection(item?.uuid, item?.slug)
                      }
                    >
                      <span className="name">{item?.name}</span>
                      <span className="time">
                        {moment.utc(item?.date).format('HH:mm')}
                      </span>
                    </S.PatientCard>
                  ))
                )}
              </S.PatientsList>
            </S.CardContainer>
          </S.LeftSection>

          <S.RightSection>
            {slotsVerification?.quantity < 60 && (
              <ReminderAlert
                title={translate('home.reminderTitle')}
                description={translate('home.reminderDescription')}
                onClick={() => history.push('/configurar-agenda')}
              />
            )}
            <S.CardContainer>
              <S.DashboardHeader>
                <S.SectionTitle style={{ marginBottom: 0 }}>
                  {translate('dash.myDashboard')}
                </S.SectionTitle>
                <S.PeriodSelector>
                  <button type="button" onClick={subPeriod}>
                    <ChevronLeft size={24} color="#666" />
                  </button>
                  <span>
                    {moment(new Date(period.year, period.month - 1))
                      .locale('pt-br')
                      .format('MMM/YYYY')}
                  </span>
                  <button
                    type="button"
                    onClick={addPeriod}
                    disabled={
                      period.month === new Date().getMonth() + 1 &&
                      period.year === new Date().getFullYear()
                    }
                  >
                    <ChevronRight size={24} color="#666" />
                  </button>
                </S.PeriodSelector>
              </S.DashboardHeader>

              <S.MetricsGrid>
                <S.MetricCard>
                  <div className="info">
                    <span className="label">
                      {translate('dash.inProgress')}
                    </span>
                    <span className="value">{metrics.slots_occupied}</span>
                  </div>
                  <div className="icon-wrapper">
                    <img src={icon4} alt={translate('dash.inProgress')} />
                  </div>
                </S.MetricCard>

                <S.MetricCard highlighted={slotsVerification?.quantity < 60}>
                  <div className="info">
                    <span className="label">
                      {translate('dash.openSchedules')}
                    </span>
                    <span className="value">{metrics.slots_total}</span>
                  </div>
                  <div className="icon-wrapper">
                    <img src={icon2} alt={translate('dash.openSchedules')} />
                  </div>
                </S.MetricCard>

                <S.MetricCard>
                  <div className="info">
                    <span className="label">{translate('dash.started')}</span>
                    <span className="value">{metrics.started}</span>
                  </div>
                  <div className="icon-wrapper">
                    <img src={icon4} alt={translate('dash.started')} />
                  </div>
                </S.MetricCard>

                <S.MetricCard>
                  <div className="info">
                    <span className="label">
                      {translate('dash.finished30min')}
                    </span>
                    <span className="value">{metrics.finished}</span>
                  </div>
                  <div className="icon-wrapper">
                    <img src={icon1} alt={translate('dash.finished30min')} />
                  </div>
                </S.MetricCard>

                <S.MetricCard>
                  <div className="info">
                    <span className="label">
                      {translate('dash.finished60min')}
                    </span>
                    <span className="value">{metrics.finished_60}</span>
                  </div>
                  <div className="icon-wrapper">
                    <img src={icon1} alt={translate('dash.finished60min')} />
                  </div>
                </S.MetricCard>

                <S.MetricCard>
                  <div className="info">
                    <span className="label">{translate('dash.canceled')}</span>
                    <span className="value">{metrics.canceled}</span>
                  </div>
                  <div className="icon-wrapper">
                    <img src={icon3} alt={translate('dash.canceled')} />
                  </div>
                </S.MetricCard>

                <S.MetricCard>
                  <div className="info">
                    <span className="label">
                      {translate('dash.canceledLess30min')}
                    </span>
                    <span className="value">{metrics.canceled_by_30_min}</span>
                  </div>
                  <div className="icon-wrapper">
                    <img
                      src={icon3}
                      alt={translate('dash.canceledLess30min')}
                    />
                  </div>
                </S.MetricCard>

                <S.MetricCard>
                  <div className="info">
                    <span className="label">
                      {translate('dash.canceledLess30min60')}
                    </span>
                    <span className="value">
                      {metrics.canceled_60_by_30_min}
                    </span>
                  </div>
                  <div className="icon-wrapper">
                    <img
                      src={icon3}
                      alt={translate('dash.canceledLess30min60')}
                    />
                  </div>
                </S.MetricCard>

                <S.MetricCard>
                  <div className="info">
                    <span className="label">
                      {translate('dash.noShow30min')}
                    </span>
                    <span className="value">{metrics.noshow}</span>
                  </div>
                  <div className="icon-wrapper">
                    <img src={icon3} alt={translate('dash.noShow30min')} />
                  </div>
                </S.MetricCard>

                <S.MetricCard>
                  <div className="info">
                    <span className="label">
                      {translate('dash.noShow60min')}
                    </span>
                    <span className="value">{metrics.noshow_60}</span>
                  </div>
                  <div className="icon-wrapper">
                    <img src={icon3} alt={translate('dash.noShow60min')} />
                  </div>
                </S.MetricCard>
              </S.MetricsGrid>
            </S.CardContainer>
          </S.RightSection>
        </S.GridContainer>
      </S.Content>

      <Footer />
    </S.Container>
  )
}

export default Dash
